module.exports = __webpack_public_path__ + "img/6e5f89fe71a825833b4532362e20018e.png";